import React from "react";
import ImageCarousel from "./ImageCarousel";



const Portfolio = (props) => {
  return (
    <section className="page-section bg-light" id="portfolio">
      <div className="container">
        <div className="text-center">
          <p>
            Over last 15 years, we made multiple temples of different sizes and shapes.
          </p>
          <p> Customise any combination of top, steps, doors, sides, drawers, cupboard, anything.</p>
          <ImageCarousel />
        </div>
      </div>
    </section>
  );
}


export default Portfolio;
